import { DataObjectHelper, DataObjectType } from "@src/to-be-removed/LocalData/General/DataObjects/DataObjectHelper";
import { DataObjectHelpers } from "@src/to-be-removed/LocalData/General/DataObjects/DataObjectHelpers";
import { t } from "i18next";

export class WorkflowTrigger<T extends DataObjectType> {
  static readonly ALL_TRIGGERS = () => [
    new WorkflowTrigger("on_deviation_create", t("main.deviationCreated"), "construction", DataObjectHelpers.deviation),
    new WorkflowTrigger("on_deviation_update_created", t("main.deviationUpdated"), "construction", DataObjectHelpers.deviationUpdate),
    new WorkflowTrigger("on_deviation_delete", t("main.deviationDeleted"), "construction", DataObjectHelpers.deviation),
    new WorkflowTrigger("on_deviation_task_create", t("main.deviationTaskCreated"), "checklist", DataObjectHelpers.deviationTask),
    new WorkflowTrigger("on_deviation_task_update", t("main.deviationTaskUpdated"), "checklist", DataObjectHelpers.deviationTask),
    new WorkflowTrigger("on_deviation_task_delete", t("main.deviationTaskDeleted"), "checklist", DataObjectHelpers.deviationTask),
    new WorkflowTrigger("every_hour", t("main.everyHour"), "repeat_one", undefined),
    new WorkflowTrigger("manually", t("main.manually"), "adjust", undefined),
  ];

  id: string;
  name: string;
  iconName: string;
  dataObjectHelper: DataObjectHelper<T> | undefined;

  constructor(id: string, name: string, iconName: string, dataObjectHelper: DataObjectHelper<T> | undefined) {
    this.id = id;
    this.name = name;
    this.iconName = iconName;
    this.dataObjectHelper = dataObjectHelper;
  }

  static getTriggerWithId(id: string): WorkflowTrigger<any> | undefined {
    return WorkflowTrigger.ALL_TRIGGERS().find((trigger) => trigger.id === id);
  }
}
